module.exports = __webpack_public_path__ + "img/w24-b2.1c3c3eea.jpg";